<template>
    <div class="apple-pay-container">
        <PuSkeleton v-if="loading" height="45px" width="300px"></PuSkeleton>
        <a href="javascript:;" class="btn" @click.prevent="startApplePaySession" v-if="isApplePayAvailable && !loading">
            <img src="/wmt/images/apple_pay.svg" alt="Pay with Apple Pay"/>
        </a>
    </div>
</template>

<script>
    import paymentMethodMixin from "@mixins/paymentMethodMixin";
    import braintree from 'braintree-web';
    import applePayApi from '@support/applePayApi'
    import CheckoutApi from "@support/checkoutApi";

    export default {
        name: 'brainTreeApplePay',
        mixins: [paymentMethodMixin],
        data: () => ({
            loading: true,
            deviceData: null,
            applePayInstance: null,
            applePaySession: null,
            isApplePayAvailable: false,
        }),
        computed: {
            token() {
                return this.paymentMethod.public.token || null;
            },
            merchantId() {
                return this.paymentMethod.public.merchant_id || null;
            },
            isDebug() {
                return this.paymentMethod.public.environment === 'sandbox';
            }
        },
        mounted() {
            this.initForm();
        },
        methods: {
            initForm() {
                if (!window.ApplePaySession || !ApplePaySession.supportsVersion(3) || !ApplePaySession.canMakePayments() || !this.token || !this.merchantId) {
                    console.debug("[braintree] Apple pay is not supported")
                    this.handlePaymentIsNotSupported();
                    return;
                }

                this.loading = true;
                applePayApi.setInstance(this)

                braintree.client.create({authorization: this.token})
                    .then(clientInstance => this.createApplePayInstance(clientInstance))
            },
            createApplePayInstance(clientInstance) {
                braintree.dataCollector.create({
                    client: clientInstance,
                }, (err, dataCollectorInstance) => {
                    if (err) {
                        console.error(err);
                        return;
                    }
                    this.deviceData = dataCollectorInstance.deviceData;
                });

                braintree.applePay.create({
                    client: clientInstance
                }).then((applePayInstance) => {
                    console.log("apple pay instance", applePayInstance);
                    this.applePayInstance = applePayInstance;

                    const merchantId = this.isDebug ? this.merchantId : applePayInstance.merchantIdentifier;
                    return ApplePaySession.canMakePaymentsWithActiveCard(merchantId).then((canMakePaymentsWithActiveCard) => {
                        if (canMakePaymentsWithActiveCard) {
                            console.debug("Apple pay available");
                            this.isApplePayAvailable = true;
                        } else {
                            console.debug("Apple pay is not available");
                            this.handlePaymentIsNotSupported();
                        }
                    });
                }).catch((err) => {
                    console.error(err);
                    this.handlePaymentIsNotSupported();
                }).finally(() => {
                    this.loading = false;
                })
            },
            startApplePaySession: function () {

                let paymentRequest = this.applePayInstance.createPaymentRequest(applePayApi.getDefaults());

                this.applePaySession = new ApplePaySession(3, paymentRequest);
                this.applePaySession.onvalidatemerchant = (e) => this.onValidateMerchant(e);
                this.applePaySession.onpaymentmethodselected = (e) => applePayApi.onPaymentMethodSelected(e);
                this.applePaySession.onshippingcontactselected = (e) => applePayApi.onShippingContactSelected(e);
                this.applePaySession.onshippingmethodselected = (e) => applePayApi.onShippingMethodSelected(e);
                this.applePaySession.onpaymentauthorized = (e) => this.onPaymentAuthorized(e);
                this.applePaySession.oncancel = (e) => applePayApi.onCancel(e);
                this.applePaySession.begin();
            },
            onValidateMerchant(event) {
                if (this.isDebug) {
                    CheckoutApi.validateAuthorizeNetApplePay(event.validationURL).then((response) => {
                        this.applePaySession.completeMerchantValidation(response.data);
                    }).catch(() => {
                        this.setRequestStatus(false);
                        this.applePaySession.abort();
                    });
                } else {
                    this.applePayInstance.performValidation({
                        validationURL: event.validationURL,
                        displayName: this.checkoutTitle
                    }).then((merchantSession) => {
                        this.applePaySession.completeMerchantValidation(merchantSession);
                    }).catch((validationErr) => {
                        console.error('Error validating merchant:', validationErr);
                        this.applePaySession.abort();
                    });
                }
            },
            onPaymentAuthorized(event) {
                applePayApi.setRequestStatus(true);
                this.applePayInstance.tokenize({
                    token: event.payment.token
                }).then(payload => {
                    applePayApi.onPaymentAuthorized(event, payload);
                }).catch(error => {
                    console.error("Error tokenize apple pay", error);
                    this.$handleError(error, 'Could not place your order. Please try again later.');
                    this.applePaySession.completePayment(ApplePaySession.STATUS_FAILURE);
                    applePayApi.setRequestStatus(false);
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .apple-pay-container {
        padding: 10px;
    }
</style>
